import { render, staticRenderFns } from "./dueForPregnancyCheckup.vue?vue&type=template&id=6f1cb0b6&scoped=true&"
import script from "./dueForPregnancyCheckup.vue?vue&type=script&lang=js&"
export * from "./dueForPregnancyCheckup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1cb0b6",
  null
  
)

export default component.exports